/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable react/no-array-index-key */
// libraries
import React from 'react';
import {
    object, string, shape, array,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Grid from '@material-ui/core/Grid';

// components
import ProductUI from './Partials/ProductUI';
import customBreakpoints from '../../../../helpers/customBreakpoints';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { determineLanguagePrefixPath } from '../../../../helpers/determineInternationalizationPath';
// import findCategoryPageByUrl from '../../../../gql/queries/findCategoryPageByURL';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
    },
    subContainer: {
        padding: '0 15px',
    },
    containerItem: {
        [theme.breakpoints.down('768')]: {
            flexGrow: '0',
            maxWidth: '50%',
            flexBasis: '50%',
            '& a': {
                margin: '0 !important',
            },
            padding: '6px 8px !important',
        },
    },
    title: {
        textAlign: 'left',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '100%',
        },
        // add other header tags here ONLY if needed for SEO/styling
        '& h3, & p': {
            textAlign: 'left',
            fontSize: '20px',
            letterSpacing: '0.99px',
            float: 'left',
            width: '50%',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                textAlign: 'center',
                width: '100%',
                padding: 0,
            },
            paddingLeft: '35px',
        },
    },
    topTrendingProductsBlock: {
        textAlign: 'center',
        position: 'relative',
        width: '100%',
        maxWidth: '1350px',
        margin: '0 auto',
        [theme.breakpoints.down('1025')]: {
            width: '100%',
        },
    },
    viewAllCountriesBtn: {
        borderRadius: '3px',
        textTransform: 'uppercase',
        textAlign: 'center',
        padding: '5px 15px',
        float: 'right',
        margin: '16px 35px',
        '& a': {
            textDecoration: 'none',
            fontWeight: '600',
            color: theme.palette.white,
            letterSpacing: '0.5px',
            fontSize: '15px',
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            float: 'none',
            margin: '20px',
            width: 'auto',
            padding: '10px 20px',
        },
    },
    notFoundBtn: {
        width: '95%',
        float: 'none',
        margin: '35px 0px',
        padding: '12px',
    },
    notFoundTitle: {
        width: '100%',
        fontSize: '26px',
        textAlign: 'center',
        letterSpacing: '0.86px',
        marginTop: '10px',
        fontWeight: '600',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            width: '60%',
            display: 'inline-block',
        },
    },
});

const TrendingProductsBuilder = ({
    classes,
    blockData: {
        title = '',
        title_font_color = '',
        group = [],
        button_background_color = '',
        button_text = '',
        button_text_color = '',
        button_link = {},
    },
    brand = {},
    ssrDeviceType = '',
    pageType = '',
}) => (
    <div className={classes.topTrendingProductsBlock}>
        <Grid container className={classes.root}>
            <Grid container>
                <Grid item xs={12}>
                    { pageType === 'template_error_page' ? <p className={classes.notFoundTitle}>Shop Our Most Popular Countries</p>
                        : (
                            <div className={classes.title} style={{ color: title_font_color }}>
                                <p className={classes.title}>{title}</p>
                                <div className={classes.viewAllCountriesBtn} style={{ display: ssrDeviceType === 'mobile' || (ssrDeviceType === 'desktop' && pageType === 'template_error_page')  ? 'none' : 'block', color: button_text_color, backgroundColor: button_background_color }}>
                                    <a href={determineLanguagePrefixPath(button_link.href)}>{button_text}</a>
                                </div>
                            </div>
                        )}
                </Grid>
            </Grid>
            <Grid container justify="space-evenly" alignItems="flex-start" spacing={2} className={classes.subContainer}>
                {group?.map((product) => (
                    <Grid key={product.country_name} item className={classes.containerItem}>
                        <ProductUI productData={product} brand={brand} />
                    </Grid>
                ))}
            </Grid>
        </Grid>
        <div className={`${classes.viewAllCountriesBtn} ${(ssrDeviceType !== 'mobile' && pageType === 'template_error_page') ? classes.notFoundBtn : ''}`} style={{ display: (ssrDeviceType !== 'mobile' && pageType !== 'template_error_page')  ? 'none' : 'inline-block', color: button_text_color, backgroundColor: button_background_color }}>
            <a href={determineLanguagePrefixPath(button_link.href)}>{button_text}</a>
        </div>
    </div>
);

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

TrendingProductsBuilder.propTypes = {
    brand: shape({
        domain: string,
    }).isRequired,
    classes: object.isRequired,
    blockData: shape({
        title: string,
        title_font_color: string,
        group: array,
        button_background_color: string,
        button_text: string,
        button_text_color: string,
        button_link: shape({
            title: string,
            href: string,
        }),
    }).isRequired,
    ssrDeviceType: string.isRequired,
    pageType: string,
};

TrendingProductsBuilder.defaultProps = {
    pageType: '',
};

const enhance = compose(
    withStyles(styles),
    connect(mapStateToProps),
);
export default enhance(TrendingProductsBuilder);
